<p class="p2 _result"
   [class]="status?.error ? 'col-2' : 'col-3'">{{message || (holdPlace ? '&nbsp' : '')}}</p>